
import moment from 'moment'
import store from '../config/store'

export default {
  props: {
    login: {
      type: Boolean,
      default: false
    }
  },
  
  data: () => ({
    store,
    bankName: process.env.VUE_APP_NAME
  }),
  
  computed: {
    year () {
      return moment().format('YYYY')
    }
  },
  
  methods: {
    changeLocale (lang) {
      this.$i18n.locale = lang
      store.data.lang = this.$i18n.locale
      window.localStorage.setItem(store.localStorageKey, JSON.stringify(store.data))
      
      this.$validator.localize(this.$i18n.locale)
      this.$bus.$emit('scrollToTop')
      this.showBanner('success', this.$i18n.t('banner.success.language_changed'))
    }
  }
}
